"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRouteUpdate = function (_a, pluginOptions) {
    var location = _a.location;
    var trackingId = pluginOptions.trackingId;
    if (!trackingId)
        return;
    var pathname = location.pathname, search = location.search, hash = location.hash;
    window.ga('send', 'pageview', pathname + search + hash);
};
